import React, { useEffect } from 'react';
import { RadioInputSection, SelectInput } from '../HealthPlan/styled';

export default function DropdownInputField(props) {
  const { element, inputFieldErrorHandler, index, showNewUI } = props;
  useEffect(() => {
    document.getElementById('dropdown').selectedIndex = -1;
  }, []);
  return (
    <RadioInputSection showNewUI={showNewUI}>
      <h2>{element?.question_text}</h2>
      <SelectInput
        name="dropdown"
        id="dropdown"
        onChange={(event) => {
          inputFieldErrorHandler(event.target.value, index);
        }}
      >
        {element?.options.map((item, i) => {
          return (
            <option key={item} value={item}>
              {item}
            </option>
          );
        })}
      </SelectInput>
    </RadioInputSection>
  );
}
